var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNextStatusArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.66667L9.44667 4.66667L7.06 7.06L8 8L12 4L8 0L7.06 0.94L9.44667 3.33333L0 3.33333V4.66667Z",
    fill: "#535D6A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextStatusArrow);
export default __webpack_public_path__ + "static/media/next-status-arrow.4c03675d204c8c9877412b00d25dbdec.svg";
export { ForwardRef as ReactComponent };